import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  unstable_HistoryRouter as HistoryRouter,
  Route,
  Routes,
  useNavigate,
} from 'react-router-dom';

import CustomHtmlHead from 'components/PageLayout/CustomHtmlHead';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { PoliciesPagesType } from 'enums/curo/PoliciesPagesTypes';
import { resetCuroStore } from 'handlers/curo-handlers/actions';
import ApplicationProcess from 'pages/CuroPages/ApplicationProcess';
import LoaderStep from 'pages/CuroPages/ApplicationProcess/steps/LoaderStep';
import ApplyProcess from 'pages/CuroPages/ApplyProcess';
import HomePage from 'pages/CuroPages/HomePage';
import MailOfferNextSteps from 'pages/CuroPages/MailOfferNextSteps';
import MailOfferProcess from 'pages/CuroPages/MailOfferProcess';
import NotFoundPage from 'pages/CuroPages/NotFoundPage';
import PoliciesPage from 'pages/CuroPages/PoliciesPage';
import SignInProcess from 'pages/CuroPages/SignInProcess';
import CuroRouterLayout from 'route-layout/CuroRouterLayout';
import RedirectHandler from 'route-layout/RedirectHandler';
import RequiredAuth from 'route-layout/RequredAuth';

import { history } from './historyRouter';

const LogOutHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetCuroStore());

    navigate(CuroAppRoute.SignIn);
  }, []);

  return <LoaderStep />;
};

const CuroAppRouter = () => {
  return (
    <HistoryRouter history={history}>
      <CustomHtmlHead />
      <Routes>
        <Route element={<CuroRouterLayout />}>
          <Route path={CuroAppRoute.Logout} element={<LogOutHandler />} />
          <Route path={CuroAppRoute.MailOffer} element={<MailOfferProcess />} />
          <Route path={CuroAppRoute.MailOfferNextSteps} element={<MailOfferNextSteps />} />
          <Route path={CuroAppRoute.ApplyProcess} element={<ApplyProcess />} />
          <Route element={<RedirectHandler />}>
            <Route path="*" element={<NotFoundPage />} />
            <Route path={CuroAppRoute.SignIn} element={<SignInProcess />} />
            <Route path={CuroAppRoute.Home} element={<HomePage />} />
            <Route
              path={CuroAppRoute.TermsAndConditions}
              element={<PoliciesPage type={PoliciesPagesType.General} />}
            />
            <Route
              path={CuroAppRoute.PrivacyNotice}
              element={<PoliciesPage type={PoliciesPagesType.PrivacyNotice} />}
            />
            <Route
              path={CuroAppRoute.OnlinePrivacyPolicy}
              element={<PoliciesPage type={PoliciesPagesType.OnlinePrivacyPolicy} />}
            />
            <Route
              path={CuroAppRoute.TermsOfUse}
              element={<PoliciesPage type={PoliciesPagesType.TermsOfUse} />}
            />
            <Route
              path={CuroAppRoute.ConsentForElectronicSignatures}
              element={<PoliciesPage type={PoliciesPagesType.ConsentForElectronicSignatures} />}
            />
            <Route
              path={CuroAppRoute.GeneralDisclosures}
              element={<PoliciesPage type={PoliciesPagesType.Disclosures} />}
            />
          </Route>
          <Route element={<RequiredAuth />}>
            <Route path={CuroAppRoute.ResumeProcess} element={<ApplicationProcess />} />
          </Route>
        </Route>
      </Routes>
    </HistoryRouter>
  );
};

export default CuroAppRouter;
